module.exports = __webpack_public_path__ + "static/media/Redfaktor-50-Hz.e374c911.png";